import React from 'react'
import R from '../../assets/R.jpg'
import AHossain from '../../assets/AHossain.jpg'
import AB from '../../assets/AB.JPG'
import SN from '../../assets/SN.jpg'
import S from '../../assets/S.JPG'
import AK from '../../assets/AK.jpg'
import D from '../../assets/D.jpg'
import DG from '../../assets/DG.jpg'
import SDE from '../../assets/SDE.jpg'
import RK from '../../assets/RK.jpg'
import SM from '../../assets/SM.jpg'
import TTS from '../../assets/TTS.jpg'
import T from '../../assets/T.jpg'
import NK1 from '../../assets/NK1.jpg'
import NK2 from '../../assets/NK2.jpg'
import HA from '../../assets/HA.jpg'
import anuj from '../../assets/anuj.jpg'
import ryt from '../../assets/ryt.jpg'
import pandey from '../../assets/pandey.jpg'
import samr from '../../assets/samr.jpg'
import samn from '../../assets/samn.jpg'
import swagata from '../../assets/swagata.jpg'
import rao from '../../assets/rao.JPG'
import SMitra from "../../assets/SMitra.jpg";
import SSah from "../../assets/SSah.jpg";
import Prashanth from "../../assets/Prashanth.jpg";
import ANagar from "../../assets/ANagar.jpg";
import RYadav from "../../assets/RYadav.jpg";
import YSinha from "../../assets/YSinha.jpeg";
import AJaiswal from "../../assets/AJaiswal.jpg";
import AChaudhary from "../../assets/AChaudhary.png";
import AKrishna from "../../assets/AKrishna.jpg";
import ZHossain from "../../assets/ZHossain.png";
import RChowdhury from "../../assets/RChowdhury.jpg";
import SMookherjee from "../../assets/SMookherjee.jpg";
import SRajwar from "../../assets/SRajwar.jpg";
import ADey from "../../assets/ADey.png";
import DBardhan from "../../assets/DBardhan.jpg";
import DKher from "../../assets/Dkher.jpg";
import SAcharya from "../../assets/SAcharya.jpg";
import ANagarajan from "../../assets/ANagarajan.jpeg";
import ATalukder from "../../assets/ATalukder.jpg";
import PMistri from "../../assets/PMistri.jpg";
import APal from "../../assets/APal.jpg";
import BSana from "../../assets/BSana.jpg";
import ATiwari from "../../assets/ATiwari.jpeg";
import PDutta from "../../assets/PDutta.jpg";
import SSamanta from "../../assets/SSamanta.jpg";
import RKumar from "../../assets/RKumar.jpg";
import Nimcheki from "../../assets/Nimcheki.jpg";
import PGupta from "../../assets/PGupta.jpg";
import YMAHESHWARI from "../../assets/YMAHESHWARI.jpeg";
import Yoshita from "../../assets/IMG_20241215_112108 - Yoshitha Reddy.jpg";
import Aditi from "../../assets/00954e8e-854b-42fc-9111-b70abba815b8 - ADITI Mahto.jpeg";
import Alla from "../../assets/IMG_20251111_145449 - Vamsi Alla.jpg";
import Manoj from "../../assets/IMG_5440 - Manoj Kumar Doki.jpg";
import Azmeera from "../../assets/IMG_20250709_001815_251 - Azmeera Akhil.webp";
import Shazeena from "../../assets/20250308_124939 - Shazeena Hussain.jpg";
import Milita from "../../assets/IMG_20250225_121913 - Milita Ghosh.jpg";
import Abhishekh from "../../assets/chess_img - David Abhisekh G.jpg";
import Rakshit from "../../assets/pic2 - Sima Rakshit.jpg";
import Jaswanth from "../../assets/IMG_4175 - JASWANTH KANDREGULA.JPG";
import CharanTeja from "../../assets/PochepalliCharamTeja-TechHead.jpeg";
import "./Alumni.css"
import NavBar from '../NavBar'
import Footer from '../Footer'

function Alumni() {
  return (
    <div>
        <NavBar/>
        <div className="container team__member">
            <div className="section-title">
                <h1>Our Alumni</h1>
                <hr className="hr" width="50%" style={{ margin: "0 auto" }} />
            </div>
            
            <div className='outer members__box__wrap'>
                <div className="section-title">
                    <h3>ChESS Members from Batch of 2020</h3>
                </div>
                <div className="members__grid">
                    <div className="member__card">
                        <img src={TTS} alt="TT Sriram" />
                        <div className="member__overlay">
                            <p className="member__name">TT Sriram</p>
                            <p className="member__role">President (2019-20)</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={R} alt="Ritika Das" />
                        <div className="member__overlay">
                            <p className="member__name">Ritika Das</p>
                            <p className="member__role">Vice President (2019-20)</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={NK1} alt="Naveen Kumar" />
                        <div className="member__overlay">
                            <p className="member__name">Naveen Kumar</p>
                            <p className="member__role">General Secretary (2019-20)</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={T} alt="Tejaswi Shah" />
                        <div className="member__overlay">
                            <p className="member__name">Tejaswi Shah</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={AK} alt="Aritra Karmakar" />
                        <div className="member__overlay">
                            <p className="member__name">Aritra Karmakar</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={RK} alt="Rakesh Kumar Sisodiya" />
                        <div className="member__overlay">
                            <p className="member__name">Rakesh Kumar Sisodiya</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={SDE} alt="Subhadeepa Dey" />
                        <div className="member__overlay">
                            <p className="member__name">Subhadeepa Dey</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className='outer members__box__wrap'>
                <div className="section-title">
                    <h3>ChESS Members from Batch of 2021</h3>
                </div>
                <div className="members__grid">
                    <div className="member__card">
                        <img src={DG} alt="Debjit Goswami" />
                        <div className="member__overlay">
                            <p className="member__name">Debjit Goswami</p>
                            <p className="member__role">President (2020-21)</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={AHossain} alt="Adil Hossain" />
                        <div className="member__overlay">
                            <p className="member__name">Adil Hossain</p>
                            <p className="member__role">Vice President (2020-21)</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={HA} alt="Harshit Anand" />
                        <div className="member__overlay">
                            <p className="member__name">Harshit Anand</p>
                            <p className="member__role">General Secretary (2020-21)</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={AB} alt="Boyina Venkata Akhil" />
                        <div className="member__overlay">
                            <p className="member__name">Boyina Venkata Akhil</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={D} alt="Darpan Shyamkumar Agarwal" />
                        <div className="member__overlay">
                            <p className="member__name">Darpan Shyamkumar Agarwal</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={S} alt="Sucharita Pal" />
                        <div className="member__overlay">
                            <p className="member__name">Sucharita Pal</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={NK2} alt="Nishant Kumar" />
                        <div className="member__overlay">
                            <p className="member__name">Nishant Kumar</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={SN} alt="Saurav Nag" />
                        <div className="member__overlay">
                            <p className="member__name">Saurav Nag</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className='outer members__box__wrap'>
                <div className="section-title">
                    <h3>ChESS Members from Batch of 2022</h3>
                </div>
                <div className="members__grid">
                    <div className="member__card">
                        <img src={ryt} alt="Rhythm Aich" />
                        <div className="member__overlay">
                            <p className="member__name">Rhythm Aich</p>
                            <p className="member__role">President (2021-22)</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={SM} alt="Saumyajeet Mukherjee" />
                        <div className="member__overlay">
                            <p className="member__name">Saumyajeet Mukherjee</p>
                            <p className="member__role">Vice President (2021-22)</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={samn} alt="Sammanoy Mukherjee" />
                        <div className="member__overlay">
                            <p className="member__name">Sammanoy Mukherjee</p>
                            <p className="member__role">General Secretary (2021-22)</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={swagata} alt="Swagata Laxmi Sengupta" />
                        <div className="member__overlay">
                            <p className="member__name">Swagata Laxmi Sengupta</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={pandey} alt="Amar Kumar Pandey" />
                        <div className="member__overlay">
                            <p className="member__name">Amar Kumar Pandey</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={samr} alt="Samriddho Saha" />
                        <div className="member__overlay">
                            <p className="member__name">Samriddho Saha</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={rao} alt="BHV Prasad" />
                        <div className="member__overlay">
                            <p className="member__name">BHV Prasad</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={anuj} alt="Anuj Patel" />
                        <div className="member__overlay">
                            <p className="member__name">Anuj Patel</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className='outer members__box__wrap'>
                <div className="section-title">
                    <h3>ChESS Members from Batch of 2023</h3>
                </div>
                <div className="members__grid">
                    <div className="member__card">
                        <img src={SMitra} alt="Soumyajeet Mitra" />
                        <div className="member__overlay">
                            <p className="member__name">Soumyajeet Mitra</p>
                            <p className="member__role">President</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={SSah} alt="Sonali Sah" />
                        <div className="member__overlay">
                            <p className="member__name">Sonali Sah</p>
                            <p className="member__role">Vice President</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={Prashanth} alt="Prashanth Kumar" />
                        <div className="member__overlay">
                            <p className="member__name">Prashanth Kumar</p>
                            <p className="member__role">General Secretary</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={ANagar} alt="Anand Nagar" />
                        <div className="member__overlay">
                            <p className="member__name">Anand Nagar</p>
                            <p className="member__role">Convenor</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={RYadav} alt="Rishabh Yadav" />
                        <div className="member__overlay">
                            <p className="member__name">Rishabh Yadav</p>
                            <p className="member__role">Treasurer</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={YSinha} alt="Yash Sinha" />
                        <div className="member__overlay">
                            <p className="member__name">Yash Sinha</p>
                            <p className="member__role">Creative Head</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={AJaiswal} alt="Ankit Jaiswal" />
                        <div className="member__overlay">
                            <p className="member__name">Ankit Jaiswal</p>
                            <p className="member__role">Event Management Head</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={AChaudhary} alt="Ayush Chaudhary" />
                        <div className="member__overlay">
                            <p className="member__name">Ayush Chaudhary</p>
                            <p className="member__role">Sponsorship and Publicity Head</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={AKrishna} alt="Abhinav Krishna" />
                        <div className="member__overlay">
                            <p className="member__name">Abhinav Krishna</p>
                            <p className="member__role">Web Development Head</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className='outer members__box__wrap'>
                <div className="section-title">
                    <h3>ChESS Members from Batch of 2024</h3>
                </div>
                <div className="members__grid">
                    <div className="member__card">
                        <img src={ZHossain} alt="Zeshan Hossain Sardar" />
                        <div className="member__overlay">
                            <p className="member__name">Zeshan Hossain Sardar</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={RChowdhury} alt="Riddhi Chowdhury" />
                        <div className="member__overlay">
                            <p className="member__name">Riddhi Chowdhury</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={SMookherjee} alt="Sujaan Mookherjee" />
                        <div className="member__overlay">
                            <p className="member__name">Sujaan Mookherjee</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={SRajwar} alt="Sushanta Rajwar" />
                        <div className="member__overlay">
                            <p className="member__name">Sushanta Rajwar</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={ADey} alt="Anupam Dey" />
                        <div className="member__overlay">
                            <p className="member__name">Anupam Dey</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={DBardhan} alt="Dev Bardhan Singh" />
                        <div className="member__overlay">
                            <p className="member__name">Dev Bardhan Singh</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={DKher} alt="Devesh kher" />
                        <div className="member__overlay">
                            <p className="member__name">Devesh kher</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={SAcharya} alt="Sayak Acharya" />
                        <div className="member__overlay">
                            <p className="member__name">Sayak Acharya</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={ANagarajan} alt="Anagha Nagarajan" />
                        <div className="member__overlay">
                            <p className="member__name">Anagha Nagarajan</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className='outer members__box__wrap'>
                <div className="section-title">
                    <h3>ChESS Members from Batch of 2025</h3>
                </div>
                <div className="members__grid">
                    <div className="member__card">
                        <img src={ATalukder} alt="Argha Talukder" />
                        <div className="member__overlay">
                            <p className="member__name">Argha Talukder</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={PMistri} alt="Palash Mistri" />
                        <div className="member__overlay">
                            <p className="member__name">Palash Mistri</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={APal} alt="Ananya Pal" />
                        <div className="member__overlay">
                            <p className="member__name">Ananya Pal</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={BSana} alt="Bikram Sana" />
                        <div className="member__overlay">
                            <p className="member__name">Bikram Sana</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={ATiwari} alt="Ashita Tiwari" />
                        <div className="member__overlay">
                            <p className="member__name">Ashita Tiwari</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={PDutta} alt="Pratik Dutta" />
                        <div className="member__overlay">
                            <p className="member__name">Pratik Dutta</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={SSamanta} alt="Soumyadeep Samanta" />
                        <div className="member__overlay">
                            <p className="member__name">Soumyadeep Samanta</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={RKumar} alt="Ranjan Kumar" />
                        <div className="member__overlay">
                            <p className="member__name">Ranjan Kumar</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={Nimcheki} alt="Nimcheki" />
                        <div className="member__overlay">
                            <p className="member__name">Nimcheki</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={PGupta} alt="Priyanka Gupta" />
                        <div className="member__overlay">
                            <p className="member__name">Priyanka Gupta</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                    <div className="member__card">
                        <img src={YMAHESHWARI} alt="Yash Maheswari" />
                        <div className="member__overlay">
                            <p className="member__name">Yash Maheswari</p>
                            <p className="member__role">Executive Member</p>
                        </div>
                    </div>
                </div>
            </div>
             <div className='outer members__box__wrap'>
    <div className="section-title">
        <h3>ChESS Members from Batch of 2026</h3>
    </div>

    <div className="members__grid">

        <div className="member__card">
            <img src={Jaswanth} alt="Jaswanth Kandregula" loading="lazy" />
            <div className="member__overlay">
                <p className="member__name">Jaswanth Kandregula</p>
                <p className="member__role">President</p>
            </div>
        </div>

        <div className="member__card">
            <img src={Alla} alt="Vamsi Alla" style={{objectPosition: "30% 20%"}} loading="lazy" />
            <div className="member__overlay">
                <p className="member__name">Vamsi Alla</p>
                <p className="member__role">General Secretary</p>
            </div>
        </div>

        <div className="member__card">
            <img src={Aditi} alt="Aditi Mahto" loading="lazy" />
            <div className="member__overlay">
                <p className="member__name">Aditi Mahto</p>
                <p className="member__role">Vice President</p>
            </div>
        </div>

        <div className="member__card">
            <img src={Abhishekh} alt="David Abhisekh G" loading="lazy" />
            <div className="member__overlay">
                <p className="member__name">David Abhisekh G</p>
                <p className="member__role">Treasurer</p>
            </div>
        </div>

        <div className="member__card">
            <img src={Manoj} alt="Manoj Kumar Doki" loading="lazy" />
            <div className="member__overlay">
                <p className="member__name">Manoj Kumar Doki</p>
                <p className="member__role">Convener</p>
            </div>
        </div>

        <div className="member__card">
            <img src={Yoshita} alt="Yoshitha Reddy" loading="lazy" />
            <div className="member__overlay">
                <p className="member__name">Yoshitha Reddy</p>
                <p className="member__role">Design Head</p>
            </div>
        </div>

        <div className="member__card">
            <img src={Azmeera} alt="Azmeera Akhil" loading="lazy" />
            <div className="member__overlay">
                <p className="member__name">Azmeera Akhil</p>
                <p className="member__role">Operation Head</p>
            </div>
        </div>

        <div className="member__card">
            <img src={Shazeena} alt="Shazeena Hussain" loading="lazy" />
            <div className="member__overlay">
                <p className="member__name">Shazeena Hussain</p>
                <p className="member__role">Sponsorship Head</p>
            </div>
        </div>

        <div className="member__card">
            <img src={Milita} alt="Milita Ghosh" loading="lazy" />
            <div className="member__overlay">
                <p className="member__name">Milita Ghosh</p>
                <p className="member__role">Publicity Head</p>
            </div>
        </div>

        <div className="member__card">
            <img src={Rakshit} alt="Srinjay Rakshit" loading="lazy" />
            <div className="member__overlay">
                <p className="member__name">Srinjay Rakshit</p>
                <p className="member__role">Event Head</p>
            </div>
        </div>

        <div className="member__card">
            <img src={CharanTeja} alt="Pochepalli Charan Teja" loading="lazy" />
            <div className="member__overlay">
                <p className="member__name">Pochepalli Charan Teja</p>
                <p className="member__role">Tech Head</p>
            </div>
        </div>
         <div className="member__card">
            <img src={PDutta} alt="Pratik Dutta" loading="lazy" />
            <div className="member__overlay">
                <p className="member__name">Pratik Dutta</p>
                <p className="member__role">M.Tech Representative</p>
            </div>
        </div>

    </div>
</div>
            </div> 
        <Footer/>  
    </div>
  )
}

export default Alumni